// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__t8Rzg","option":"styles_option__3aGcl","active":"styles_active__HY6qp"};